const {
    NOTIFICATION_DEEP_LINK_HB_CHORE,
    NOTIFICATION_DEEP_LINK_HB_REQ_MONEY,
    NOTIFICATION_DEEP_LINK_SAVE_MONEY,
    COLLECTIVOS_NTIFCTN_CRRNT_TO_PAYROLL,
    COLLECTIVOS_NTIFCTN_HAS_NO_PAYROLL_AND_CURRENT_ACNT,
    NOTIFICATIONS_STATUS_PENDING,
    NOTIFICATIONS_STATUS_DELIVERED,
    NOTIFICATIONS_STATUS_ERROR,
} = require('constants/index');

const { hash } = require('utilities/hash');

const { formatText } = require("core/i18n").i18n;

function getNotificationActions(notificationDeeplink, flagBasedFeatures, getChoreDetail, getMoneyRequestDetails, moneySavingsRequestDetails) {
    let actions = [], messageLinkAction = {};
    let savingMoneyEnabled = flagBasedFeatures ? flagBasedFeatures.get('hb-saving-mechanism-enabled') : false;
    switch(notificationDeeplink) {
        case NOTIFICATION_DEEP_LINK_HB_CHORE: {
            messageLinkAction = {
                path: `/chores`,
                action: getChoreDetail
            }
            actions = [
                {
                    value: formatText('openYoungChoresList-paymentButton'),
                    path: `/chores/payment-chore/`,
                    addReferenceIdInPath: true,
                    action: getChoreDetail
                },
                {
                    value: formatText('openYoungChoresList-rejectButton'),
                    path: `/chores/reject-chore/`,
                    addReferenceIdInPath: true,
                    action: getChoreDetail
                }
            ];
            break;
        }
        case NOTIFICATION_DEEP_LINK_HB_REQ_MONEY: {
            actions = [
                {
                    value: formatText('moneyRequestView-acceptButton'),
                    path: `/accept/moneyrequest`,
                    action: getMoneyRequestDetails
                },
                {
                    value: formatText('openYoungChoresList-rejectButton'),
                    path: `/reject/moneyrequest`,
                    action: getMoneyRequestDetails
                }
            ];
            break;
        }
        case NOTIFICATION_DEEP_LINK_SAVE_MONEY: {
            if(savingMoneyEnabled){
                actions = [
                    {
                        value: formatText('moneySavingsRequest-acceptButton'),
                        path: `/accept/savingsrequest`,
                        action: moneySavingsRequestDetails
                    },
                    {
                        value: formatText('moneySavingsRequest-rejectButton'),
                        path: `/reject/savingsrequest`,
                        action: moneySavingsRequestDetails
                    }
                ];
            }
            break;
        }
        case COLLECTIVOS_NTIFCTN_CRRNT_TO_PAYROLL: {
            actions = [
                {
                    value: formatText('collectivesNotification-convertToPayrollButton'),
                    path: `/purchase/upgrade-to-payroll-account`
                },
                {
                    value: formatText('collectivesNotification-hirePayrollButton'),
                    path: `/purchase/payroll-account?skip-check=true`
                }
            ];
            break;
        }
        case COLLECTIVOS_NTIFCTN_HAS_NO_PAYROLL_AND_CURRENT_ACNT: {
            actions = [
                {
                    value: formatText('collectivesNotification-hirePayrollButton'),
                    path: `/purchase/payroll-account?skip-check=true`
                }
            ];
            break;
        }
    }

    return {
        actions,
        messageLinkAction
    }
}

function getNotificationMessage(message, iban) {
    let customMessages = {};

    switch (message) {
        case 'PENDING':
            customMessages.linkText = 'userNotifications-customLinkPending';
            customMessages.message = formatText('userNotifications-customMessagePending');
            break;
        case 'READY':
            customMessages.linkText = 'userNotifications-customLinkReady';
            customMessages.message = formatText('userNotifications-customMessageReady');
            break;
        case 'ACTIVE':
            customMessages.linkText = null;
            customMessages.message = formatText('userNotifications-customMessageActive', [iban]);
            break;
        default:
            customMessages.linkText = null;
            customMessages.message = null;
            break;
    }

    return customMessages;
}

function getCustomMessages(immNotification) {
    let customMessage = {};
    const message = immNotification.get('message').toUpperCase();
    const iban = immNotification.get('iban');

    switch(immNotification.get('messageType')) {
        case 'NOTIFICATION':
            customMessage = getNotificationMessage(message, iban);
            break;
        case 'OTHER':
            customMessage = {
                linkText : formatText(immNotification.get('linkTextKey','userNotifications-customLinkPending')),
                message : immNotification.get('message')
            }
            break;
        default:
            customMessage = {
                linkText : null,
                message : null
            }
    }
    return customMessage;
}

function isMessageNotADisclaimer(messageType) {
    return (messageType || '').trim().toUpperCase() !== 'DISCLAIMER';
}

// function hasNotificationType(messageType) {
//     return trim(messageType).toUpperCase() === 'NOTIFICATION';
// }

function hasPushNotificationType(messageType) {
    return (messageType || '').trim().toUpperCase() === 'PUSH';
}

function hasOtherNotificationType(messageType) {
    return (messageType || '').trim().toUpperCase() === 'OTHER';
}

function isUnreadNotification(status) {
    return (status === NOTIFICATIONS_STATUS_PENDING || status === NOTIFICATIONS_STATUS_DELIVERED || status === NOTIFICATIONS_STATUS_ERROR);
}


function getIsNotificationClickable(immNotification) {
    const clickableType = hasPushNotificationType(immNotification.get('messageType')) || hasOtherNotificationType(immNotification.get('messageType'))
    return clickableType
        && immNotification.get('actionRequired')
        && immNotification.get('deeplink') === NOTIFICATION_DEEP_LINK_HB_CHORE
}

function generateHashedPan(last4DigitPan, immCards){
    let hashedPan = '';

    immCards.get('byId').every((immCard) => {
        const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
        const last4DigitPanCard = fullPanNumber.substr(fullPanNumber.length - 4);
        const isPanNumberMatched = last4DigitPan === last4DigitPanCard;
        if(isPanNumberMatched){
            hashedPan = hash(fullPanNumber);
        }
        return !isPanNumberMatched;
    });
    return hashedPan;
}

function cardSuccessCallback(url, response, immCards, onSuccess, history) {
    let hashedPan = '';

    const last4DigitPan = response.last4DigitPan || response.last4DigitOfPan;
    hashedPan = generateHashedPan(last4DigitPan, immCards);
    if(hashedPan) {
        history.push(`/myprofile/cards/${hashedPan}${url}`);
    }
    onSuccess && onSuccess();
}


function handleActionClick(event, immCards, action , onSuccess, onError, history) {
    event && event.stopPropagation();
    if(action.action) {
        const data = {
            isExpanded: true,
            path: action.path,
            successCallback: (url, response) => cardSuccessCallback(url, response, immCards, onSuccess, history),
            errorCallback: onError
        }
        action.action(action.referenceId, data);
    } else {
        history.push(`/myprofile${action.path}`);
        onSuccess && onSuccess();
    }
}


function decorateNotification(immNotification, immCards, flagBasedFeatures, getChoreDetail, getMoneyRequestDetails, moneySavingsRequestDetails, history) {
    const { actions, messageLinkAction } = getNotificationActions(immNotification.get('deeplink'), flagBasedFeatures, getChoreDetail, getMoneyRequestDetails, moneySavingsRequestDetails);
    const { linkText, message } = getCustomMessages(immNotification)


    return immNotification.merge({
        actions: actions,
        isNotificationClickable: getIsNotificationClickable(immNotification),
        messageLinkAction: messageLinkAction,
        onHandleActionClick: (event, action, onSuccess, onError) => handleActionClick(event, immCards, action, onSuccess, onError, history),
        isUnreadNotification: isUnreadNotification(immNotification.get('deliveryStatus')),
        linkText: linkText,
        message: message || immNotification.get('message')
    })
}

function filterValidAndUnreadNotificationsToDisplay(immNotification) {
    return isMessageNotADisclaimer(immNotification.get('messageType')) && isUnreadNotification(immNotification.get('deliveryStatus'));
}

function filterUnreadNotifications(immNotification) {
    return isUnreadNotification(immNotification.get('deliveryStatus'));
}

function filterValidNotificationsToDisplay(immNotification) {
    return isMessageNotADisclaimer(immNotification.get('messageType'))
}

module.exports = {
    decorateNotification,
    getNotificationActions,
    filterUnreadNotifications,
    filterValidNotificationsToDisplay,
    filterValidAndUnreadNotificationsToDisplay
};
